import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {Alert, AlertType} from './alert';
import {AlertService} from './alert.service';

@Component({
    selector: 'app-alert',
    template: `
        <div style="position: fixed; right: 36px; top: 24px; z-index: 9999;">
            <div *ngFor="let alert of alerts" [class]="cssClass(alert)">
                <svg class="icon icon-attantion">
                    <use xlink:href="#icon-attantion"></use>
                </svg>
                <p class="alert-text" *ngIf="!alert?.isPDF">{{ 'Alerts.'+alert.message | translate }}</p>
                <p class="alert-text" *ngIf="alert?.isPDF">{{ alert.message }}</p>
                <button class="close" (click)="removeAlert(alert)"><span>&times;</span></button>
            </div>
        </div>
    `
})

export class AlertComponent implements OnInit, OnDestroy {

    alerts: Alert[] = [];
    private subscription = new Subscription();
    private alertTimeouts: ReturnType<typeof setTimeout>[] = [];

    constructor(private alertService: AlertService) {
    }

    ngOnInit(): void {
        this.subscription.add(
            this.alertService.getAlert().subscribe((alert: Alert) => {
                if (!alert) {
                    this.alerts = [];
                    return;
                }
                this.alerts.push(alert);
                const timeoutId = setTimeout(() => this.removeAlert(alert), 5000);
                this.alertTimeouts.push(timeoutId);
            }),
        );
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.alertTimeouts.forEach(timeoutId => clearTimeout(timeoutId));
    }

    public removeAlert(alert: Alert) {
        this.alerts = this.alerts.filter(x => x !== alert);
    }

    public cssClass(alert: Alert) {
        switch (alert.type) {
            case AlertType.Success:
                return 'alert alert-success';
            case AlertType.Errors:
                return 'alert alert-danger';
            case AlertType.Info:
                return 'alert alert-info';
            case AlertType.Warning:
                return 'alert alert-warning';
            default:
                return '';
        }
    }
}
